import { colors, Row, Cell } from '@dexma/ui-components';
import styled from 'styled-components';
import { EditorContent } from '@tiptap/react';

export const StyledWidgetTextInput = styled.div<{ $error: boolean }>`
    padding: 20px 30px 0px 30px;
    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .form-control-input,
    .form-control-textarea {
        border-color: ${(props) => props.$error && colors.red};
    }

    .error {
        color: ${colors.red};
        text-align: left;
    }
`;

export const StyledRowActivableInput = styled(Row)`
    justify-content: space-between;
`;

export const StyledCellActivableInput = styled(Cell)`
    margin-right: 1.5rem;
`;

export const StyledWidgetTextFooterInput = styled.div`
    margin-top: 8px;
    line-height: 14px;
    font-size: 12px;
    font-weight: 400;
    color: ${colors.gray500};
`;

export const StyledTiptapWrapper = styled.div<{ $displayTableBorders: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;

    h1 {
        font-size: 36px;
    }

    h2 {
        font-size: 28px;
    }

    h3 {
        font-size: 22px;
    }

    h4 {
        font-size: 18px;
    }

    h5 {
        font-size: 16px;
    }

    img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        margin: 4px 0;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        margin: 8px 0;
        font-size: 10px;
    }

    th,
    td {
        border: ${({ $displayTableBorders }) => ($displayTableBorders ? '1px solid #d9d9d9' : 'none')};
        padding: 3px 6px;
        min-width: 40px;
        vertical-align: top;
        word-break: break-word;
        line-height: 1.25;
    }

    th p,
    td p {
        margin: 0;
    }

    th p + p,
    td p + p {
        margin-top: 0.25em;
    }

    th {
        background: #f7f7f7;
        font-weight: 600;
    }

    .tableWrapper {
        overflow-x: auto;
    }

    [data-resize-handle] {
        width: 12px;
        height: 12px;
    }

    [data-resize-handle='top-left'],
    [data-resize-handle='bottom-right'] {
        cursor: nwse-resize;
    }

    [data-resize-handle='top-right'],
    [data-resize-handle='bottom-left'] {
        cursor: nesw-resize;
    }
`;

export const StyledEditorContent = styled(EditorContent)<{ $isBeingEdited: boolean }>`
    flex: 1;
    min-height: 0;
    height: 100%;

    .ProseMirror mark {
        font-style: inherit;
        font-weight: inherit;
        padding: 0;
    }

    ${({ $isBeingEdited }) =>
        $isBeingEdited &&
        `
      overflow-y: auto;

      .ProseMirror-selectednode[data-resize-container] img {
          outline: 2px solid rgba(104, 206, 248, 0.6);
          outline-offset: -2px;
          border-radius: 4px;
      }
    `}
`;
